import { Component, Input } from '@angular/core';
import { Day } from 'src/main/webapp/assets/models/iter.model';

/**ToDo Documentazione */
@Component({
  selector: 'app-recap-city',
  styleUrls: ['./recap-city.component.scss'],
  templateUrl: './recap-city.component.html'
})
export class RecapCityComponent {
  @Input() public day: Day | undefined;
  @Input() public serviceIcons: any;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public showCity(day?: Day): boolean {
    // return !!day?.city_name && (day?.showDetailsOnItinerary || day?.isIndipendentStay);
    return !!day?.city_name;
    // return !!day?.city_name && !day?.isLastDay;
  }
}
